const CYCLE_RESETS = {
  '24_hour': {
    name: $localize`24 Hour`,
    hours: 24,
  },
  '34_hour': {
    name: $localize`34 Hour`,
    hours: 34,
  },
  '36_hour': {
    name: $localize`36 Hour`,
    hours: 36,
  },
  '72_hour': {
    name: $localize`72 Hour`,
    hours: 72,
  },
  'ca_34_hour': {
    name: $localize`34 Hour (CA)`,
    hours: 34,
  },
  'ca_24_hour': {
    name: $localize`24 Hour (CA)`,
    hours: 24,
  },
  'tx_34_hour': {
    name: $localize`34 Hour (TX)`,
    hours: 34,
  },
  'tx_24_hour': {
    name: $localize`24 Hour (TX)`,
    hours: 24,
  },
  'ak_34_hour': {
    name: $localize`34 Hour (AK)`,
    hours: 34,
  },
  'ak_24_hour': {
    name: $localize`24 Hour (AK)`,
    hours: 24,
  },
  'fl_34_hour': {
    name: $localize`34 Hour (FL)`,
    hours: 34,
  },
  'fl_24_hour': {
    name: $localize`24 Hour (FL)`,
    hours: 24,
  },
};

export { CYCLE_RESETS };
